/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, ReactNode } from 'react';
import { withRouter, BrowserRouter, Link, RouteComponentProps, Switch } from 'react-router-dom';
import { Tab, Tabs } from '@material-ui/core';

interface TabProps {
  label: string;
  value: string;
  to: string;
  className: string;
}

interface NavTabsProps extends RouteComponentProps {
  initialValue?: string;
  tabs?: TabProps[];
  basePath: string;
  children?: ReactNode[];
}

const NavTabs: React.FC<NavTabsProps> = ({ initialValue, tabs, basePath, location, children }: NavTabsProps) => {
  const [currentValue, setCurrentValue] = useState(initialValue);

  useEffect(() => {
    const { pathname } = location;
    let component = pathname.slice(basePath.length);
    if (component.startsWith('/')) {
      component = component.slice(1);
    }
    setCurrentValue(component);
  }, [basePath, location]);

  return (
    <div>
      <BrowserRouter basename={basePath}>
        <Tabs
          value={currentValue}
          onChange={(e, newValue) => setCurrentValue(newValue)}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          {tabs && tabs.map((tab, i) => <Tab key={i} component={Link} {...tab} />)}
        </Tabs>
        <Switch>{children}</Switch>
      </BrowserRouter>
    </div>
  );
};

NavTabs.defaultProps = {
  initialValue: '',
  tabs: [],
  children: [],
};

export default withRouter(NavTabs);
